let getters = {
  states (state) {
    return state.states
  },
  boards (state) {
    return state.boards
  },
  filteredBoards (state) {
    return state.filteredBoards
  },
  selectedState (state) {
    return state.selectedState
  },
  selectedStateId (state) {
    return state.selectedStateId
  },
  selectedServiceProvider (state) {
    return state.selectedServiceProvider
  },
  selectedServiceProviderQuestion (state) {
    return state.selectedServiceProviderQuestion
  },
  selectedAccountNumber (state) {
    return state.selectedAccountNumber
  },
  selectedBillFetch (state) {
    return state.selectedBillFetch
  },
  selectedPartial (state) {
    return state.selectedPartial
  },
  selectedBbps (state) {
    return state.selectedBbps
  },
  pageMessage (state) {
    return state.pageMessage
  }
}
export default getters



// WEBPACK FOOTER //
// ./src/store/postpaid/getters.js